import { ColorGrid } from '@laranda/lib-sysutil';
import { FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DameAsunto, DameSistemas } from '@laranda/lib-ucontrol';
import { SysFecha, fech_a_HTfech, fechaHoy, HTfech_a_fech, inicio_anno, HTfechaHoy } from '@laranda/lib-sysutil';
import swal from 'sweetalert2';

@Component({
  selector: 'app-sistemas',
  templateUrl: './sistemas.component.html',
  styleUrls: ['./sistemas.component.scss']
})
export class SistemasComponent implements OnInit {
  desde: string;
  hasta: string;
  fSistemas: FormControl = new FormControl(0);
  sysFecha = new SysFecha();

  dtColumnas: DataTables.ColumnSettings[] = [
    { title: this.colorGrid.tablaH('Num Asunto'), data: 'Nuasunto' },
    { title: this.colorGrid.tablaH('Sistema'), data: 'Sistema' },
    { title: this.colorGrid.tablaH('Descripción'), data: 'Descmax' },
    { title: this.colorGrid.tablaH('Fecha'), data: 'Fecha' }
  ];


  constructor(
    public dameAsunto: DameAsunto,
    public dameSistemas: DameSistemas,
    private colorGrid: ColorGrid
    ) { }

  ngOnInit() {
    this.fSistemas.valueChanges.subscribe(valor => { this.dameAsunto.ParamIn.siste = valor; });
    if (this.dameAsunto.ParamIn.desde !== '' && this.dameAsunto.ParamIn.hasta !== '') {
      this.desde = fech_a_HTfech(this.dameAsunto.ParamIn.desde);
      this.hasta = fech_a_HTfech(this.dameAsunto.ParamIn.hasta);
    } else {
      this.desde = fech_a_HTfech(inicio_anno(fechaHoy()));
      this.hasta = HTfechaHoy();
    }
    if (this.dameAsunto.ParamIn.siste !== 0) { this.fSistemas.patchValue(this.dameAsunto.ParamIn.siste); }
    this.dameSistemas.consultar();

    // this.dameAsunto.CadOut = [];
    this.dameAsunto.visible = true;
  }


  getBuscar() {

    if (this.desde > this.hasta) {
      swal.fire('Error en Fechas', 'Fecha desde no pude ser mayor a la fecha hasta'  , 'error');

    } else {
      this.dameAsunto.ParamIn.desde = HTfech_a_fech(this.desde);
      this.dameAsunto.ParamIn.hasta = HTfech_a_fech(this.hasta);
      this.dameAsunto.ParamIn.siste = this.fSistemas.value;            
      this.dameAsunto.consultar();
    }
  }

// openModal(id: string) {
//   this.modalService.open(id);
// }

//   closeModal(id: string) {
//   this.modalService.close(id);
// }
}
